// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../app/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".y-axis .tick line,.y-axis path{stroke:#c4c4c4}.y-axis .tick line{stroke-dasharray:0,0}.y-axis-label,.y-axis .tick text{fill:var(--tbd-chart-text-color,#8f8f8f);font-size:12px;font-family:Roboto,sans-serif}.y-grid-line line{stroke:#d3d3d3;stroke-opacity:1;shape-rendering:crispEdges}", ""]);
// Exports
module.exports = exports;
